import { useEffect } from 'react';
import { insuranceRateComparisonSubject } from '../../store/csw/rate-recommendation.observables';

export const useLegacyInsuranceRecommendation = ({ fulfillmentPlanId, compareRates, setShouldShowComparison }) => {
  useEffect(() => {
    const subscription = insuranceRateComparisonSubject.subscribe(
      ({ ratedFulfillmentPlanId, isComparing, userRates, comparedRates, comparedInsuranceProviderId, metadata }) => {
        if (ratedFulfillmentPlanId !== fulfillmentPlanId) {
          return;
        }

        if (isComparing) {
          setShouldShowComparison(false);
          return;
        }

        compareRates({
          userRatesTotalCost: userRates.totalCost,
          comparedRatesTotalCost: comparedRates.totalCost,
          comparedInsuranceProviderId,
          metadata,
        });
      },
    );

    return () => subscription.unsubscribe();
  }, [compareRates, fulfillmentPlanId, setShouldShowComparison]);
};
